"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PurchaseOrderFilter = /** @class */ (function () {
    function PurchaseOrderFilter() {
    }
    return PurchaseOrderFilter;
}());
exports.PurchaseOrderFilter = PurchaseOrderFilter;
